export default "/kiban/_next/static/images/16_6L_2-2-2_withBH_staggered-8204764e741c380a19cf666c36c96646.png";